module.exports = __webpack_public_path__ + "static/media/cover_banner.0be75d33.png";